import React from "react";

export const SchemasContext = React.createContext(null)